import { render, staticRenderFns } from "./filedConfig.vue?vue&type=template&id=6039f1e8&"
import script from "./filedConfig.vue?vue&type=script&lang=js&"
export * from "./filedConfig.vue?vue&type=script&lang=js&"
import style0 from "./filedConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports